<template>
	<button class="global-currency-select">
		<ClientOnly>
			<template #fallback>
				<div class="global-currency-select__activator">
					<div class="global-currency-select__currency">
						{{ useCookie('currency') }}
					</div>
					<GlobalIcon name="arrow-down" :height="16" class="global-currency-select__select-icon" />
				</div>
			</template>
			<v-menu attach class="global-currency-select__menu" scroll-strategy="close">
				<template #activator="{ props }">
					<div class="global-currency-select__activator" v-bind="props">
						<template v-if="!loading">
							<div class="global-currency-select__currency">
								{{ selectedCurrency }}
							</div>
							<GlobalIcon name="arrow-down" :height="16" class="global-currency-select__select-icon" />
						</template>
						<template v-else>
							<v-progress-circular indeterminate :size="24" :width="3" color="var(--primary-color)" />
							<GlobalIcon name="arrow-down" :height="16" class="global-currency-select__select-icon" />
						</template>
					</div>
				</template>
				<v-list>
					<v-list-item
						v-for="(currency, i) in availableCurrencies"
						:key="i"
						:value="currency"
						@click="changeCurrency(CurrenciesMap[currency]?.iso)">
						<v-list-item-title>
							<div class="global-currency-select__item">
								<div class="global-currency-select__item-value">
									{{ CurrenciesMap[currency]?.iso }}
								</div>
							</div>
						</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</ClientOnly>
	</button>
</template>

<script setup lang="ts">
const selectedCurrency = ref('PLN')
const currencyStore = useCurrenciesStore()
const router = useRouter()
const route = useRoute()
const loading = ref(false)
const availableCurrencies = computed(() => {
	return availableCurrenciesArray.filter((currency) => currencyStore.getExchangeRateForCurrency(currency))
})

const assignCurrencyOnStart = () => {
	const currency = useCookie('currency').value
	if (currency) {
		selectedCurrency.value = currency
	}
}
onMounted(() => {
	if (route.query.refreshed) {
		// delete query params
		router.replace({
			path: route.path,
			query: {},
		})
	}
	assignCurrencyOnStart()
})

const changeCurrency = (currency: string) => {
	selectedCurrency.value = currency
	setCurrency(currency)
}

const setCurrency = (currency: string) => {
	useCookie('currency').value = currency
	useCookie('currency-exchange-rate').value = currencyStore.getExchangeRateForCurrency(currency)?.toString()
	// router.go(0)
	// window.location.reload(true)
	loading.value = true
	window.location.href = `${window.location.pathname}?refreshed=${Date.now()}`
}
</script>

<style lang="scss">
@import './Select.scss';
</style>
